import { IERC20_ABI, LON_STAKING_ABI } from '../constants/abis/index.js';
import { lonAddress, lonStakingAddress } from '../constants/addresses.js';
import { ContextHost } from '../service/contextHost.js';
import {} from './type.js';
import { formatUnits, isAddress } from 'viem';
export class Profile extends ContextHost {
    constructor(config) {
        super({ env: config.env, chainId: config.chainId });
    }
    async getLonBalance(userAddress) {
        const balance = await this.publicClient.readContract({
            address: lonAddress[this.chainId],
            abi: IERC20_ABI,
            functionName: 'balanceOf',
            args: [userAddress],
        });
        return formatUnits(balance, 18);
    }
    async getXLonBalance(userAddress) {
        const balance = await this.publicClient.readContract({
            address: lonStakingAddress[this.chainId],
            abi: LON_STAKING_ABI,
            functionName: 'balanceOf',
            args: [userAddress],
        });
        return formatUnits(balance, 18);
    }
    async getTokenBalance(tokenAddress, userAddress) {
        if (!isAddress(tokenAddress) || !isAddress(userAddress)) {
            throw new Error('Not address');
        }
        const balance = await this.publicClient.readContract({
            address: tokenAddress,
            abi: IERC20_ABI,
            functionName: 'balanceOf',
            args: [userAddress],
        });
        const decimals = await this.publicClient.readContract({
            address: tokenAddress,
            abi: IERC20_ABI,
            functionName: 'decimals',
        });
        return formatUnits(balance, decimals);
    }
    async getStakersCooldowns(userAddress) {
        const result = await this.publicClient.readContract({
            address: lonStakingAddress[this.chainId],
            abi: LON_STAKING_ABI,
            functionName: 'stakersCooldowns',
            args: [userAddress],
        });
        return result;
    }
    async getCooldownRemainSeconds(userAddress) {
        const result = await this.publicClient.readContract({
            address: lonStakingAddress[this.chainId],
            abi: LON_STAKING_ABI,
            functionName: 'cooldownRemainSeconds',
            args: [userAddress],
        });
        return result;
    }
    async previewRageExit(userAddress) {
        const rageExit = await this.publicClient.readContract({
            address: lonStakingAddress[this.chainId],
            abi: LON_STAKING_ABI,
            functionName: 'previewRageExit',
            args: [userAddress],
        });
        return {
            receiveAmount: formatUnits(rageExit[0], 18),
            penaltyAmount: formatUnits(rageExit[1], 18),
        };
    }
}
//# sourceMappingURL=index.js.map